import { CachedOutlined, InfoOutlined } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import { Badge } from "@vds/badges";
import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import "./CameraInfoTable2.css";
import { Cell, Table, TableBody, TableHead, TableHeader, TableRow } from "@vds/tables";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { listRoi, setCameraCaliration } from "../../../api/RoiServiceManager";
import { getCompanion } from "../../utility/tableUtils";
import {
  fetchCameraCVApps,
  findImageForList,
  findImageID,
  getFovDetailedCalibrationType,
  getFovDetailedStatus,
  getLicenseTypeDisplayed,
  convertCamelCaseToText
} from "../../utility/Utils";
import AppTable from "./AppTable";

import { Button, TextLink } from "@vds/buttons";
import { Notification } from "@vds/notifications";
import { RadioButtonGroup } from "@vds/radio-buttons";
import { Body, Title } from "@vds/typography";
import { Spinner } from "react-bootstrap";
import { ImageDownloadMedia } from "../../../model/mediaService.js";
import { getPairedCamSnapShotIds } from "../../../model/cameraonboardingService.js";
import { setCalibrating, updateDeviceFovList, updateDeviceCameraList, refreshCameraPage, updateCameraCalibrationStatus, saveStreamImageMapping, getAllCameraAndFovsDevices, changeLicenseType, updateDevices } from "../../../store/actions";
import { showNotificationBanner, showCalibrationBanner  } from "../../../store/actions/index.jsx";
import { formattedTimeStamp } from "../../../utils/index.js";
import axiosInstance from "../../axiosInterceptor";
import { hasPermission } from "../../utility/permissionUtils.js";
import { fetchVisionDevicesEndPoint } from "./../../../configuration.js";
import ManualCalibration from "../../../../src/pages/CameraOnboarding/manualCalibration.jsx";
import { Loader } from "@vds/loaders";
import { encodeOrDecodeRtspCredentials } from "../../../global/utility/Utils";
import { NOTIFICATION_TYPES, BUTTON_LABELS, SUBTITLES, TITLES, MODAL_LABELS, RADIO_OPTIONS, RADIO_LABELS, CALIBRATION_MODES, CALIBRATION_MODE_VALUES, CALIBRATE_CONSTNATS } from "../../../constants/cameraInfoConstants";
import { DEVICE_CONSTANTS } from "../../../constants/DeviceConstants";
import { HTTP_STATUS_CODES } from "../../../global/constants/constants";
import { capitalizeWords } from "../../../api/utils";
import { BANNER_TYPES } from "../../constants/constants.js";
import { getFovObjWithStreamId } from "../../utility/deviceTableUtils.js";
import { LICENSE_NOTIFICATION_MESSAGES, LICENSE_NOTIFICATION_TYPES, LICENSE_VALUES, LICENSE_TYPES, getActiveLicenseSku, LICENSE_SKU_PATTERNS, LICENSE_ACTION_TYPES } from "../../constants/licensesConstants.js";
import { LightText } from "../../../features/camerOnboarding/discoveredCameraOnboarding/styles.jsx";
import ErrorTemplate from "../errorTemplate/ErrorTemplate.jsx";


const CameraInfoTable = (props) => {
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const { state } = useLocation();
  const dispatch = useDispatch();
  const stateData = state?.data;
  const stateData1 = state?.banner;
  const { roiList } = useSelector((state) => state.deviceReducer);
  const { selectedCameraQR, calibrating } = useSelector((state) => state.cameraonboardingReducer);
  const { cameraList = [], fovList } = useSelector((state) => state.deviceReducer);
  const streamImages = useSelector((state) => state.imagesReducer.streamImages);
  const cvAppList = useSelector(
        (state) => state.cvAppReducer.cvAppList
      );
  const timerRef = useRef();

  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableRow, setTableRow] = useState([]);
  const [companionDetail, setCompanionDtails] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [refreshDeviceTable, setRefreshDeviceTable] = useState(false);
  const [fetchCVApp, setFetchCVApp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [roi, setRoi] = useState({});
  const [subscribedCvApps, setSubscribedCvApps] = useState({});
  const [isLicenseValid, setIsLicenseValid] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFovId, setSelectedFovId] = useState(null);
  const [isUnsubscribeMode, setIsUnsubscribeMode] = useState(false);
  const [selectedApps, setSelectedApps] = useState(new Set());
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const [farposition, setFarPosition] = useState([]);
  const [nearSize, setNearSize] = useState([]);
  const [farSize, setFarSize] = useState([]);
  const [manualCount, setmanualCount] = useState(0);
  const [manualSnapshot, setManualSnapshot] = useState([]);
  const [selectdeviceId, setSelectDeviceId] = useState("");
  const [isStreamCalibrated, setIsStreamCalibrated] = useState(false);
  const [detailcallcount, setDetailcallcount] = useState(1);
  const [calibrationStatus, setCalibrationStatus] = useState(false);
  const [isCameraInfo, setIsCameraInfo] = useState(true);
  const [appList, setAppList] = useState([]);
  let FOVList;
  try {
    const parsed = JSON.parse(sessionStorage.getItem("fovList") || "null");
    FOVList = Array.isArray(parsed) ? parsed : fovList || [];
  } catch (e) {
    FOVList = fovList || [];
  }
  const [fovNames, setFovNames] = useState([]);
  const [roiIDs, setRoiIDs] = useState([]);
  const [calibrationModal, setCalibrationModal] = useState(false);
  const [fovDetails, setFovDetails] = useState();
  const [streamImage, setStreamImage] = useState();
  const [roiApiResponse, setRoiApiResponse] = useState(null);
  const [showManualCalibrationModal, setShowManualCalibrationModal] = useState(false);
  const [loader, setLoader] = useState(false);

  const licenseList = useSelector((state) => state.licenseReducer.licenses);

  const getAllLicenseTypesDisplayed = (licenses, licenseList) => {
    if (!licenses?.length) return "No License";
    return licenses?.map((lic) => getLicenseTypeDisplayed(lic, licenseList))?.join(", ");
  };
  const getLicenseInOrder = (licenses) => {
    if (licenses?.[0] === LICENSE_SKU_PATTERNS.ENROLLED_APPEARANCE_V2) {
      return [...licenses].reverse();
    }
    return licenses;
  };

  const handleLicenseTypeClick = (sku) => {
    const licenseRecord = licenseList?.find((lic) => lic?.sku === sku);
    dispatch({
      type: LICENSE_ACTION_TYPES.SET_SELECTED_LICENSE_RECORD,
      payload: { ...licenseRecord, sku, license: sku, billingAccount: activeSession?.accountId }
    });
    navigate("/licensedetails", {
      state: { pendingSearchTerm: cameraDetails?.name || "", originPage: "cameraDetails", cameraData: cameraDetails }, replace: true
    });
  };

  const checkHasApps = (row) => {
    const hasApps = roiList.filter((roi) => roi.parentdeviceid === row?.id);
    const hasCvApps = hasApps.filter((item) => item?.cvapps?.length > 0).length > 0;
    return hasCvApps;
  };

  // Check if license is suspended
  const checkIsLicenseSuspended = (row) => {
    return row?.licensesinfo?.[0]?.status?.toLowerCase() === 'suspended' || false;
  };

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const showLicenseSuspendedBanner = () => {
    const notificationInfo = {
      type: BANNER_TYPES.INFORMATION,
      priority: BANNER_TYPES.WARNING,
      showNotification: true,
      title: LICENSE_NOTIFICATION_TYPES.LICENSE_SUSPENDED,
      subtitle: LICENSE_NOTIFICATION_MESSAGES.LICENSE_SUSPENDED_MESSAGE,
    };
    dispatch(showNotificationBanner(notificationInfo));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const {
    cameraDetails,
    setTableData1,
    handleDelete,
    cameraCVAppList,
    liveFeedList,
    storeSubscribedCvApps,
    isDeleteModalOpen,
    setLiveFeedList,
    onFetchSubscribedCvAppsError
  } = props;

  const parentDeviceList = JSON.parse(sessionStorage.getItem("deviceList"));

  const fetchData = async () => {
    const data = await getLiveFeedChannelTableData(liveFeedList);
    setTableData(data);
    setTableData1(data);
  };

  const getLiveFeedChannelTableData = async (liveFeedList) => {
    if (liveFeedList?.length > 0) {
      const tableData = await Promise.all(
        liveFeedList.map(async (l, i) => {
          const cvApps = await fetchCameraCVApps(l.uid, activeSession, cvAppList);
          let status = l.state;
          let color = "green";
          if (status === "ready") {
            status = "Online";
          } else if (status === "ready1") {
            status = "Offline";
            color = "";
          }
          let images = [];
          if (props?.deviceCvApps) {
            props.deviceCvApps
              .filter((d) => d.deviceid === l.id)
              .map((apps) => {
                if (apps) {
                  const appid = apps?.appid;
                  if ((cvAppList || []).length > 0) {
                    const app = cvAppList.find((cv) => cv.id === appid);
                    if (app) {
                      images.push(app.image);
                    }
                  }
                }
              });
          }

          return {
            name: l.name,
            id: l.id,
            status: status,
            color: color,
            cvApps: cvApps,
            images: images,
            ...l
          };
        })
      );
      return tableData;
    }
    return [];
  };

  const fetchDetails = async (tableData) => {
    try {
      const responses = await Promise.all(
        tableData.map((row) => {
          const payload = {
            accountname: activeSession?.accountId,
            filter: {
              $expand: "fields,cvapp"
            },
            fovidentifiers: [
              {
                deviceid: row.id
              }
            ]
          };
          return listRoi(payload, activeSession);
        })
      );
      // listRoi swallows its own errors and resolves with undefined instead of rejecting,
      // so a failed call must be detected here rather than relying on Promise.all to throw.
      if (responses.some((response) => response === undefined)) {
        throw new Error("One or more listRoi calls failed");
      }
      const cvapps = responses.flat().flatMap((item) => item?.cvapps).filter((item) => item !== undefined);
      const names = cvapps.map((item) => (item ? item.name : "")).filter((name) => name !== "");
      const uniqueNames = names.filter((value, index, names) => names.indexOf(value) === index);
      storeSubscribedCvApps({ names: uniqueNames });
    } catch (error) {
      console.log("Error fetching details:", error);
      if (onFetchSubscribedCvAppsError) {
        onFetchSubscribedCvAppsError();
      } else {
        storeSubscribedCvApps({ names: undefined });
      }
    }
  };
  useEffect(() => {
    if (tableData && tableData?.length && isDeleteModalOpen) {
      fetchDetails(tableData);
    }
  }, [tableData, isDeleteModalOpen]);
  const loadCvAppListTableData = async () => {
    setTableRow([]);
    try {
      await fetchCameraCVApps("", activeSession, cvAppList);
      setRefreshDeviceTable(true);
    } catch (err) {
      setTableLoading(false);
    }
  };

  const closeModal = () => {
    setCalibrationModal(false);
    setShowManualCalibrationModal(false);
    setIsLoading(false);
    setIsManual(false);
  };

  const handleCalibrationClick = (fov) => {
    setCalibrationModal(true);
    setFovDetails(fov);
    setSelectedFovId(fov?.id);
    setSelectDeviceId(fov?.id);
    // RadioButtonGroup's defaultValue only sets the visual selection and never fires onChange,
    // so isManual (what Calibrate actually branches on) must be seeded here to match it.
    setIsManual(fov?.fields?.calibration?.mode === CALIBRATION_MODES.MANUAL);
    fetchCalibrationModalStreamImage(fov);
  };

  const handleCalibrationSuccess = (deviceid, calibrationMode) => {
    setTableData((prev) =>
      prev.map((row) => (row.id === deviceid ? { ...row, state: "registered", fields: { ...(row.fields || {}), calibration: { ...(row.fields?.calibration || {}), mode: calibrationMode, status: 0 } } } : row))
    );
    dispatch(updateDeviceFovList(fovList.map((fov) => fov.id === deviceid ? { ...fov, state: "registered", fields: { ...(fov.fields || {}), calibration: { ...(fov.fields?.calibration || {}), mode: calibrationMode, status: 0 } } } : fov)));
    dispatch(showCalibrationBanner({ showNotification: false }));
    dispatch(
      showCalibrationBanner({
        type: NOTIFICATION_TYPES.STREAM_CALIBRATION,
        priority: NOTIFICATION_TYPES.INFO,
        data: { title: fovDetails?.name ? `${fovDetails.name} ${TITLES.STREAM_CALIBRATION}` : TITLES.STREAM_CALIBRATION, subtitle: SUBTITLES.STREAM_CALIBRATION, buttonLabel: BUTTON_LABELS.REFRESH },
        isDismissible: false,
        hideCloseButton: false,
        dispatchAction: getAllCameraAndFovsDevices(),
        cameraInfoDispatchAction: refreshCameraPage(true),
        deviceId: fovDetails?.parentdeviceid,
        showNotification: true
      })
    );
    setCalibrationStatus(true);
  };

  const handleAutomaticCalibrate = async () => {
    let config;
    let deviceid = fovDetails?.id;
    setIsLoading(true);
    setLoader(true);
    if (isManual) {
      handleAddAppsClick(true);
      setLoader(false);
      return;
    }
    dispatch(setCalibrating(true));
    let payload = {
      accountname: activeSession?.accountId,
      resources: [
        {
          fovidentifier: {
            deviceid: deviceid
          },
          config
        }
      ]
    };
    const res = await setCameraCaliration(payload, activeSession);
    if (res === HTTP_STATUS_CODES.OK || res === HTTP_STATUS_CODES.ACCEPT) {
      handleCalibrationSuccess(deviceid, CALIBRATION_MODES.AUTOMATIC);
    } else {
      dispatch(setCalibrating(false));
      dispatch(showCalibrationBanner({
        type: NOTIFICATION_TYPES.CALIBRATION_FAILED,
        priority: NOTIFICATION_TYPES.CRITICAL,
        data: {
          title: fovDetails?.name ? `${fovDetails.name} ${TITLES.CALIBRATION_FAILED}` : TITLES.CALIBRATION_FAILED,
          subTitle: SUBTITLES.CALIBRATION_FAILED
        },
        showNotification: true,
      }));
    }
    setIsLoading(false);
    setLoader(false);
    setIsManual(false);
    setCalibrationModal(false);
  };

  const handleManualCalibrate = async () => {
    setLoader(true);
    let config;
    let deviceid = fovDetails?.id;
    const farpositionM = farposition.filter((f) => f.id === deviceid);
    const farSizeM = farSize.filter((f) => f.id === deviceid);
    const nearSizeM = nearSize.filter((f) => f.id === deviceid);
    config = {
      farposition: farpositionM[0]?.farposition ? farpositionM[0]?.farposition : 100,
      sceneparameters: {
        far_size: farSizeM[0]?.farSize ? farSizeM[0]?.farSize : 1,
        near_size: nearSizeM[0]?.nearSize ? nearSizeM[0]?.nearSize : 1
      }
    };
    let payload = {
      accountname: activeSession?.accountId,
      resources: [
        {
          fovidentifier: {
            deviceid: deviceid
          },
          config
        }
      ]
    };
    const res = await setCameraCaliration(payload, activeSession);
    if (res === HTTP_STATUS_CODES.OK || res === HTTP_STATUS_CODES.ACCEPT) {
      handleCalibrationSuccess(deviceid, CALIBRATION_MODES.MANUAL);
      const newCalibrationConfig = {
        FarPosition: config.farposition,
        SceneParameters: {
          far_size: config.sceneparameters.far_size,
          near_size: config.sceneparameters.near_size,
        },
      };
      const updatedCameraList = cameraList.map((cam) =>
        cam.id === cameraDetails?.id
          ? { ...cam, customdata: { ...cam.customdata, calibrationConfig: newCalibrationConfig } }
          : cam
      );
      dispatch(updateDeviceCameraList(updatedCameraList));
    } else {
      dispatch(showCalibrationBanner({
        type: NOTIFICATION_TYPES.CALIBRATION_FAILED,
        priority: NOTIFICATION_TYPES.CRITICAL,
        data: {
          title: fovDetails?.name ? `${fovDetails.name} ${TITLES.CALIBRATION_FAILED}` : TITLES.CALIBRATION_FAILED,
          subTitle: SUBTITLES.CALIBRATION_FAILED
        },
        showNotification: true
      }));
    }
    setIsLoading(false);
    setIsManual(false);
    setLoader(false);
    setCalibrationModal(false);
    setShowManualCalibrationModal(false);
  };

  const handleRadioChange = (value) => {
    if (value === "Manual") {
      setIsManual(true);
    } else {
      setIsManual(false);
    }
  };

  const fetchStreamDetails = async () => {
    try {
      //setLoading(true);
      const response = await axiosInstance.post(fetchVisionDevicesEndPoint(), {
        accountname: activeSession.accountId,
        filter: {
          $selection: {
            kind: "ts.device.onvif.fov",
            parentdeviceid: tableData[0]?.parentdeviceid
          },
          $sort: [{ field: "createdon", order: "desc" }],
          $expand: "fields,licenses"
        }
      });
      const result = response.data;
      setDetailcallcount(detailcallcount + 1);
      const cameraData = cameraList.filter((item) => item?.id === tableData[0]?.parentdeviceid);
      const allStreamsReady = result.length > 0 && result.every((item) => item.state === "ready" && item.fields?.calibration?.status === 100);

      // Update table with current stream statuses (ready or not)
      setLiveFeedList(result);

      if (allStreamsReady) {
        setLoading(false);
        clearTimeout(timerRef.current);
        setIsStreamCalibrated(true);
        const notificationInfo = {
          type: NOTIFICATION_TYPES.STREAM_CALIBRATION,
          priority: NOTIFICATION_TYPES.INFO,
          data: {
            title: fovDetails?.name ? `${fovDetails.name} ${TITLES.STREAM_CALIBRATION}` : TITLES.STREAM_CALIBRATION,
            subtitle: SUBTITLES.STREAM_CALIBRATION,
            buttonLabel: BUTTON_LABELS.REFRESH,
            redirectUrl: "/cameraInfoPage?cameraId=" + (cameraData?.[0]?.id || "")
          },
          isDismissible: false,
          hideCloseButton: false,
          showNotification: true
        };
        dispatch(showCalibrationBanner(notificationInfo));

        dispatch(setCalibrating(false));
        let resultedFov = {};
        const updatedFovList = fovList.map((m) => {
          const updatedItem = result.find((item) => item.id === m.id);
          if (updatedItem) {
            resultedFov = updatedItem;
            return updatedItem;
          }
          return m;
        });
        dispatch(updateDeviceFovList(updatedFovList));
        const camera = cameraList.find((item) => item?.id === resultedFov?.parentdeviceid);
        const updatedCamera = {
          ...camera,
          fovs: camera?.fovs.map((m) => (m.id == resultedFov.id ? resultedFov : m))
        };
        const cameraliting = cameraList.map((m) => (m.id == camera?.id ? updatedCamera : m));
        dispatch(updateDeviceCameraList(cameraliting));
        setCalibrationStatus(false);
      } else {
        // Update fovList with real backend data so the banner is reactive to the actual calibration status.
        const updatedFovList = fovList.map((m) => {
          const updatedItem = result.find((item) => item.id === m.id);
          return updatedItem || m;
        });
        dispatch(updateDeviceFovList(updatedFovList));
        if (
          detailcallcount > 2 &&
        result
          .map((m) => {
            return m.state;
          })
          .indexOf("ready") === -1
      ) {
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Fetch regions of interest by tag api failed", error);
      return;
    }
  };

  const filterAndCheckLicense = (stream, fov) => {
    if (!fov || !Array.isArray(fov)) return;
    const matchingItem = fov.find((item) => item?.name === stream);
    if (matchingItem && matchingItem.license) {
      setIsLicenseValid(true);
    } else {
      setIsLicenseValid(false);
    }
  };

  const calibrationOption = () => {
    const options = [
      {
        children: "Automatic",
        value: "Automatic",
        ariaLabel: "radio one",
        disabled: false
      },
      {
        children: "Manual",
        value: "Manual",
        ariaLabel: "radio three",
        disabled: false
      }
    ];

    return options;
  };

  const fetchFloorImage = async (snapshotId) => {
    try {
      setLoading(true);
      const url = await ImageDownloadMedia(snapshotId, activeSession, "", "snapshot");
      setStreamImage(url);
      setManualSnapshot(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading image:", error);
    }
  };

  const getRoiApiResponse = async (id) => {
    setLoading(true);
    const payload = {
      accountname: activeSession?.accountId,
      filter: {
        $expand: "fields,cvapp"
      },
      fovidentifiers: [
        {
          deviceid: id
        }
      ]
    };
    const response = await listRoi(payload, activeSession);
    setLoading(false);
    return response;
  };

  const getParentDetails = (fovItem, cameraList) => {
    return cameraList?.find((item) => item?.id === fovItem?.parentdeviceid);
  };

  const handleAddApps = async (row) => {
    if (checkIsLicenseSuspended(row)) {
      showLicenseSuspendedBanner();
      return;
    }
    if (!hasPermission("Apps", "Create")) {
      showPermissionsBanner();
    } else {
      const roiApiResponse = await getRoiApiResponse(row?.id);
      const record = getParentDetails(row, cameraList);
      // Use licenses array as source of truth; fall back to licensesinfo for legacy data.
      const rowSkus = row?.licenses?.length > 0
        ? row.licenses
        : row?.licensesinfo?.map(lic => lic.sku).filter(Boolean) || [];
      const state = {
        fieldOfViews: row?.name,
        FOVImagesName: row?.customdata?.imageid,
        FOVImageURL: findImageForList(streamImages, row?.id),
        FOVNames: row?.name,
        FOVId: row?.id,
        cameraId: record?.id,
        companionId: record?.parentdeviceid,
        siteSelected: record?.customdata?.location?.site,
        floorSelected: record?.customdata?.location?.floor,
        areaSelected: record?.customdata?.location?.area,
        subAreaSelected: record?.customdata?.location?.subarea,
        cameraname: record?.name,
        cameradata: cameraList,
        data: record,
        roiList: roiApiResponse,
        sku: getActiveLicenseSku(rowSkus) || LICENSE_VALUES.NO_LICENSE,
        originPage: "cameraDetails",
      };
      sessionStorage.setItem("selectedCameraInfo", JSON.stringify(state));
      if (row?.licensesinfo?.length > 0) {
        navigate("/cvAppSub", { state: state });
      } else {
        navigate("/cvAppsLicenseType", { state: state });
      }
    }
  };

  const handleEditAppsClick = (row, unsubscribeFlow=false) => {
    if (checkIsLicenseSuspended(row)) {
      showLicenseSuspendedBanner();
      return;
    }
    const record = getParentDetails(row, cameraList);
    navigate("/roi", {
      state: {
        data: record,
        streamData: getFovObjWithStreamId(row?.id, fovList),
        FOVId: row?.id,
        FOVSnapshot: row?.customdata?.imageid,
        fieldOfViews: row?.name,
        FOVName: row?.name,
        originPage: "cameraDetails",
        isUnsubscribeFlow: unsubscribeFlow,
      }
    });
  };
  const handleAddAppsClick = (calibration = false) => {
    const selectedRow = fovList?.find((fov) => fov?.id === selectedFovId);
    setIsCameraInfo(true);
    // Use licenses array as source of truth; fall back to licensesinfo for legacy data.
    const selectedRowSkus = selectedRow?.licenses?.length > 0
      ? selectedRow.licenses
      : selectedRow?.licensesinfo?.map(lic => lic.sku).filter(Boolean) || [];
    const selectedRowSku = getActiveLicenseSku(selectedRowSkus) || LICENSE_VALUES.NO_LICENSE;
    const state = {
      fieldOfViews: [selectedRow?.name],
      FOVImagesName: [selectedRow?.customdata?.imageid],
      FOVImageURL: findImageForList(streamImages, selectedRow?.id),
      FOVNames: [selectedRow?.name],
      FOVId: [selectedRow?.id],
      cameraId: cameraDetails?.id,
      companionId: cameraDetails?.parentdeviceid,
      siteSelected: cameraDetails?.customdata?.location?.site,
      floorSelected: cameraDetails?.customdata?.location?.floor,
      areaSelected: cameraDetails?.customdata?.location?.area,
      subAreaSelected: cameraDetails?.customdata?.location?.subarea,
      cameraname: cameraDetails?.name,
      data: selectedRow,
      cameradata: cameraDetails,
      action: "cameraInfo",
      roiList: roiApiResponse,
      isCameraInfo: isCameraInfo,
      defaultLicenseType: selectedRowSku,
      sku: selectedRowSku
    };
    if (selectedRowSku == LICENSE_VALUES.NO_LICENSE && !calibration) {
      navigate("/cvAppsLicenseType", { state: state });
    } else if (!calibration) {
      navigate("/cvAppSub", { state: state });
    } else {
      state.selectdeviceId = selectdeviceId;
      state.streamImage = streamImage;
      state.fovDetails = fovDetails;
      setShowManualCalibrationModal(true);
    }
  };

  useEffect(() => {
    if (liveFeedList?.length > 0) {
      fetchData();
    }
  }, [liveFeedList, props?.deviceCvApps]);

  useEffect(() => {
    if (cameraDetails?.id && parentDeviceList?.length > 0 && companionDetail?.length == 0) {
      const list = getCompanion(cameraDetails.id, parentDeviceList);
      if (list && list.length > 0) {
        setCompanionDtails(list);
      }
    }
  }, [cameraDetails, parentDeviceList]);

  useEffect(() => {
    if (stateData1) {
      setCalibrationStatus(true);
    }
  }, [stateData1]);

  // On remount (after nav), check if stream still calibrating and restart polling
  useEffect(() => {
    const parentDeviceId = tableData?.[0]?.parentdeviceid;
    if (!parentDeviceId || calibrationStatus || isStreamCalibrated) return;
    const checkPendingCalibration = async () => {
      try {
        const response = await axiosInstance.post(fetchVisionDevicesEndPoint(), {
          accountname: activeSession.accountId,
          filter: {
            $selection: {
              kind: "ts.device.onvif.fov",
              parentdeviceid: parentDeviceId
            },
            $sort: [{ field: "createdon", order: "desc" }],
            $expand: "fields,licenses"
          }
        });
        const result = response.data;
        if (result.length > 0 && !result.every((item) => item.state === "ready")) {
          setCalibrationStatus(true);
        }
      } catch (error) {
        console.error("Error checking calibration status on remount:", error);
      }
    };
    checkPendingCalibration();
  }, [tableData]);

  const fetchCalibrationModalStreamImage = async (fov) => {
    const matchingImage = findImageForList(streamImages, fov?.id);
    if (matchingImage) {
      setStreamImage(matchingImage?.imageUrl);
      setManualSnapshot(matchingImage?.imageUrl);
    } else {
      if (fov && fov?.customdata?.imageid) {
        fetchFloorImage(fov?.customdata?.imageid);
      }
    }
  };

  const refreshStreamImage = async () => {
    if (!fovDetails) return;
    try {
      setLoading(true);
      const fovData = await getPairedCamSnapShotIds(activeSession, cameraDetails?.qrcode, fovDetails?.id);
      if (fovData?.[0]?.imageid) {
        const url = await ImageDownloadMedia(fovData[0].imageid, activeSession, fovDetails?.id, "snapshot");
        if (url) {
          setStreamImage(url);
          setManualSnapshot(url);
          dispatch(saveStreamImageMapping(fovDetails.id, url, fovData[0].imagetimestamp));
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error refreshing stream image:", error);
    }
  };

  useEffect(() => {
    if (calibrationStatus) {
      fetchStreamDetails();
      const schedulePoll = () => {
        timerRef.current = setTimeout(() => {
          fetchStreamDetails();
          schedulePoll();
        }, 10000);
      };
      schedulePoll();
    }
    return () => clearTimeout(timerRef.current);
  }, [calibrationStatus]);

  useEffect(() => {
    if (isStreamCalibrated) {
      clearTimeout(timerRef.current);
      setTimeout(() => {
        fetchData();
      }, 2000);
    }
  }, [isStreamCalibrated]);

  useEffect(() => {
    const selectedRow = fovList?.find((fov) => fov.id === selectedFovId);
    if (selectedRow) {
      filterAndCheckLicense(selectedRow?.name, fovList);
    }
  }, [selectedFovId, fovList]);

  useEffect(() => {
    dispatch(setCalibrating(false));
    const fovNamesList = fovList?.map((item) => item.name);
    setFovNames(fovNamesList);
  }, []);

  const handleRtspUrl = () => {
    props.setOpenModal(true);
    props.setRtspData(tableData);
  };

  const getWidthPercentage = () => {
    return window.innerWidth * 0.8;
  };

  return (
    <>
      {loader && <Loader fullscreen={true} active={loader} disableFocusLock />}
      <div style={{ backgroundColor: "#F6F6F6", borderRadius: "8px" }}>
        <Table striped={false} bottomLine="none" padding="standard">
          <TableHead
            bottomLine="primary"
            width="50%"
            style={{
              marginBottom: "15px",
              paddingBottom: "15px",
              marginLeft: "30px"
            }}
          >
            <TableHeader
              style={{
                paddingLeft: "14px",
                fontSize: "16px",
                position: "relative",
                marginBottom: "15px",
                paddingBottom: "15px"
              }}
            >
              Stream Name
            </TableHeader>
            <TableHeader
              style={{
                fontSize: "16px",
                marginBottom: "15px",
                paddingBottom: "15px",
                paddingLeft: "10px"
              }}
            >
              Status
            </TableHeader>
            <TableHeader
              style={{
                fontSize: "16px",
                marginBottom: "15px",
                paddingBottom: "15px"
              }}
            >
              Calibration
            </TableHeader>
            <TableHeader
              style={{
                fontSize: "16px",
                marginBottom: "15px",
                paddingBottom: "15px",
                paddingLeft: "10px"
              }}
            >
              License
            </TableHeader>
            {props.isManualAdded && (
              <TableHeader
                style={{
                  fontSize: "16px",
                  marginBottom: "15px",
                  paddingBottom: "15px",
                  paddingLeft: "10px"
                }}
              >
                RTSP URL
                <div
                  data-testid="cameraInfoTableDevices_editIconHandleRTSP"
                  onClick={handleRtspUrl}
                  style={{
                    paddingLeft: "10px",
                    display: "inline-block",
                    cursor: "pointer"
                  }}
                >
                  <Icon name="edit" size="small" color="#000000" />
                </div>
              </TableHeader>
            )}
            <TableHeader
              style={{
                fontSize: "16px",
                marginBottom: "15px",
                paddingBottom: "15px",
                paddingLeft: "10px"
              }}
            >
              Apps
            </TableHeader>
          </TableHead>
          <TableBody>
            {tableData.length > 0 &&
              tableData.map((row, index) => (
                <TableRow key={index}>
                  <Cell
                    style={{
                      paddingLeft: "14px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem"
                    }}
                  >
                    <div>{row?.name}</div>
                    <Tooltip title={`Last Updated: ${formattedTimeStamp(row?.lastupdated).date +", "+ formattedTimeStamp(row?.lastupdated).time}`}>
                      <InfoOutlined fontSize="medium" />
                    </Tooltip>
                  </Cell>
                  <Cell style={{ fontSize: "14px" }}>
                    <Box className="camera-info-status-box">
                      {(() => {
                        if (calibrating && row?.id === selectdeviceId) {
                          return <Badge fillColor={"blue"}>Calibrating</Badge>;
                        }
                        const detailed = getFovDetailedStatus(row);
                        const statusText = detailed.status;
                        const isOffline =
                          row?.connectivityStatus?.toLowerCase() === DEVICE_CONSTANTS.CAMERA_OFFLINE_STATUS ||
                          statusText === DEVICE_CONSTANTS.CAMERA_OFFLINE_STATUS;
                        if (isOffline) {
                          return <Badge fillColor={"yellow"}>{capitalizeWords(DEVICE_CONSTANTS.CAMERA_OFFLINE_STATUS)}</Badge>;
                        }
                        if (statusText === DEVICE_CONSTANTS.CAMERA_ONBOARDED_STATUS) {
                          return DEVICE_CONSTANTS.CAMERA_ONLINE_STATUS;
                        }
                        return <Badge fillColor={detailed.color}>{statusText}</Badge>;
                      })()}
                    </Box>
                  </Cell>
                  <Cell>
                    <div style={{ fontSize: "14px" }}>
                      {getFovDetailedCalibrationType(row) === CALIBRATION_MODES.SKIPPED ? (
                        <Badge fillColor="yellow">{getFovDetailedCalibrationType(row)}</Badge>
                      ) : (
                        getFovDetailedCalibrationType(row)
                      )}
                      <span
                        style={{ paddingLeft: "3px", cursor: "pointer" }}
                        data-testid="cameraInfoTableDevices_calibrateRefreshIcon"
                        onClick={() => {
                          setShowManualCalibrationModal(row?.fields?.calibration?.mode?.toLowerCase() === CALIBRATION_MODES.AUTOMATIC);
                          handleCalibrationClick(row, index);
                        }}
                      >
                        <CachedOutlined fontSize="medium" />
                      </span>
                    </div>
                  </Cell>
                  <Cell style={{ paddingLeft: "14px", fontSize: "14px" }}>
                    <div className="license-grid-container">                    
                      {getLicenseInOrder(row?.licenses)?.length > 0 ? (
                        getLicenseInOrder(row?.licenses).map((sku) => (
                          <TextLink
                            key={sku}
                            type="standAlone"
                            size="small"
                            onClick={() => handleLicenseTypeClick(sku)}
                          >
                            {getLicenseTypeDisplayed(sku, licenseList)}
                          </TextLink>
                        ))
                      ) : (
                        <span>No License</span>
                      )}
                    </div>
                  </Cell>
                  {props.isManualAdded && (
                    <Cell
                      style={{
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}
                    >
                      <Tooltip title={decodeURIComponent(row?.customdata?.encoders[0]?.url)}>
                        {decodeURIComponent(row?.customdata?.encoders[0]?.url)}
                      </Tooltip>
                    </Cell>
                  )}
                  <Cell style={{ fontSize: "14px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                      }}
                    >
                      <Button
                        size="small"
                        disabled={getFovDetailedStatus(row)?.status !== "Onboarded"}
                        use="primary"
                        data-testid="cameraInfoTableDevices_addAppsButton"
                        onClick={() => handleAddApps(row)}
                      >
                        Add Apps
                      </Button>
                      <Button
                        size="small"
                        disabled={getFovDetailedStatus(row)?.status !== "Onboarded" || !checkHasApps(row)}
                        use="secondary"
                        data-testid="cameraInfoTableDevices_viewAppsButton"
                        onClick={() => handleEditAppsClick(row, false)}
                      >
                        Edit Apps
                      </Button>
                    </div>
                  </Cell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      <Modal
        opened={showModal}
        disableOutsideClick={true}
        ariaLabel="Testing Modal"
        hideCloseButton={true}
        width="500"
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px"
            }}
            data-testid="cameraInfoTableDevices_closeIconForModal"
            onClick={() => {
              setShowModal(false);
            }}
          >
            <Icon name="close" />
          </div>
        }
      >
        <ModalBody>
          <AppTable
            appList={cameraCVAppList}
            pagination={{
              position: ["bottomRight"],
              pageSize: 5
            }}
            tableLoading={tableLoading}
            tableTitle="Apps"
            style={{ minHeight: "33vh" }}
            pageName="cameraInfoPage"
            hiddenColumns={["created on"]}
            setAssociateCvAppLoading={fetchCVApp}
            fetchCVApp={fetchCVApp}
            handleDelete={handleDelete}
            setRefreshDeviceTable={loadCvAppListTableData}
          />
        </ModalBody>
      </Modal>
      <Modal
        opened={calibrationModal}
        disableOutsideClick={true}
        onOpenedChange={(isOpen) => { if (!isOpen) closeModal(); }}
        closeButton={
          <div
            className="camera-info-modal-close-btn"
            onClick={closeModal}
          >
            <Icon name="close" />
          </div>
        }
        style={showManualCalibrationModal ? { overflow: "hidden", maxHeight: "90vh" } : {}}
        width={showManualCalibrationModal ? getWidthPercentage() : "600px"}
        id={showManualCalibrationModal ? "manualCameraInCameraInfoPage" : ""}
        zIndex={1062}
      >
        {!showManualCalibrationModal && (
          <ModalTitle>
            <Title size="large" bold>
              {MODAL_LABELS.CALIBRATE_STREAM}
            </Title>
          </ModalTitle>
        )}

        <ModalBody>
          {showManualCalibrationModal && (
            <>
              {loading ? (
                <div className="fov-spinner-container ">
                  <Spinner />
                </div>
              ) : !streamImage ? (
                <Box sx={{ height: "70vh" }}>
                  <ErrorTemplate
                    title={CALIBRATE_CONSTNATS.SNAPSHOT_UNAVAILABLE}
                    description={CALIBRATE_CONSTNATS.SNAPSHOT_DESC}
                    showRefreshButton={true}
                    onRefresh={refreshStreamImage}
                    templateType="error"
                  />
                </Box>
              ) : (
                <div>
                  <ManualCalibration
                    setFarPosition={setFarPosition}
                    farposition={farposition}
                    deviceid={selectdeviceId}
                    farSize={farSize}
                    setFarSize={setFarSize}
                    nearSize={nearSize}
                    setNearSize={setNearSize}
                    imageUrl={manualSnapshot}
                    pageName="pairingFlow"
                    existingCalibrationConfig={cameraList.find((cam) => cam?.id === cameraDetails?.id)?.customdata?.calibrationConfig}
                  />
                </div>
              )}
            </>
          )}

          {!showManualCalibrationModal && (() => {
            const isCameraOffline = fovDetails?.connectivityStatus?.toLowerCase() === DEVICE_CONSTANTS.CAMERA_OFFLINE_STATUS;
            return (
              <>
                {isCameraOffline ? (
                  <Notification type={NOTIFICATION_TYPES.WARNING} hideCloseButton={true} title={TITLES.CAMERA_OFFLINE} subtitle={SUBTITLES.CAMERA_OFFLINE} />
                ) : (
                  <Notification type={NOTIFICATION_TYPES.INFO} hideCloseButton={true} title={TITLES.CALIBRATION_TIP} subtitle={SUBTITLES.CALIBRATION_TIP} />
                )}
                {loading ? (
                  <div className="calibration-spinner-container">
                    {" "}
                    <Spinner />{" "}
                  </div>
                ) : !streamImage ? (
                <div className="camera-snapshot-error" style={{ marginTop: "15px" }}>
                  <div className="camera-snapshot-error-content">
                    <Icon name="error" size="small" color="#6f7171" />
                    <LightText>Snapshot failed to load</LightText>
                  </div>
                </div>
              ) : (
                  <>
                    <img src={streamImage} alt="stream image" style={{ width: "100%", margin: "15px 0 15px 0" }} />
                  </>
                )}
                <div style={{ display: "flex", padding: "15px 15px 15px 0", gap: "8px" }}>
                  <div>
                    <Body size="large" bold>
                      {" "}
                      {fovDetails?.name}{" "}
                    </Body>
                  </div>
                  <div
                    role="button"
                    tabIndex={0}
                    aria-label="Refresh snapshot"
                    className="camera-info-refresh-btn"
                    onClick={refreshStreamImage}
                  >
                    <Icon name="sync" size="small" color="#000000" />
                  </div>
                </div>
                <RadioButtonGroup
                  key={fovDetails?.id}
                  data-testid="cameraInfoTableDevices_radioButtonGroupCalibrateOptions"
                  onChange={(e) => handleRadioChange(e.target.value)}
                  error={false}
                  defaultValue={fovDetails?.fields?.calibration?.mode ? convertCamelCaseToText(fovDetails.fields.calibration.mode) : ""}
                  data={RADIO_OPTIONS.map((opt) => {
                    if (opt.value === CALIBRATION_MODE_VALUES.MANUAL && !streamImage) {
                      return { ...opt, disabled: true, children: RADIO_LABELS.MANUAL_NO_SNAPSHOT };
                    }
                    return opt;
                  })}
                />
              </>
            );
          })()}
        </ModalBody>
          <ModalFooter
            buttonData={{
              primary: {
                width: "100%",
                children: "Calibrate",
                "data-testid": "cameraInfoTableDevices_calibrateButtonGroup",
                disabled: (!streamImage && isManual) || 
                  fovDetails?.connectivityStatus?.toLowerCase() === DEVICE_CONSTANTS.CAMERA_OFFLINE_STATUS ||
                  (showManualCalibrationModal && !streamImage),
                onClick: () => (showManualCalibrationModal ? handleManualCalibrate() : handleAutomaticCalibrate())
              },
              close: {
                width: "100%",
                children: "Cancel",
                "data-testid": "cameraInfoTableDevices_cancelButtonGroup",
                onClick: () => closeModal()
              }
            }}
          />
      </Modal>
    </>
  );
};

export default CameraInfoTable;
